import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CanvasElementType } from '@blaze-runtime/engine-domain';
import { DatasetRow } from '@blaze-shared/schema-domain';
import { useEmitTracker } from '@blaze-shared/shared-util';

import { CanvasElementComponent } from '../../canvas-elements/element-component';

import { CanvasElementBaseComponent, ColumnIdOrName } from './base.component';

type InputSelectSingleElements = Extract<CanvasElementType, 'dropdown'>;

@Component({
  selector: 'blaze-canvas-element-base-input-select-single',
  template: '',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class CanvasElementBaseInputSelectSingleComponent<
    T extends InputSelectSingleElements,
  >
  extends CanvasElementBaseComponent<T>
  implements CanvasElementComponent<T>
{
  protected outputEmitTracker = useEmitTracker();

  displayedOptions: DatasetRow[] = [];

  @ColumnIdOrName()
  labelField = 'label';
  @ColumnIdOrName()
  valueField = 'value';
}
